// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Select {
    position: relative;
    width :100%;
    border:1px solid #CFD8DE ;
    border-radius :5px;
}

.Select,
.Select div,
.Select input,
.Select span {
    box-sizing: border-box;
}
.Select.is-disabled{
    border:none;

}
.Select.is-disabled > .Select-control {
    /* background-color: #f9f9f9; */
    background-color: #c1c1c1 ;
    color : #474646;

}


.Select.is-disabled > .Select-control:hover {
    box-shadow: none;
}

.Select.is-disabled .Select-arrow-zone {
    cursor: default;
    pointer-events: none;
}
.Select.is-disabled .Select-placeholder,
.Select.is-disabled > .Select-control .Select-value {
    color: #3b3b3b;
}

.Select-control {
    /* background-color: #dec9ce;
     */
     background-color:  transparent;
    border-radius: 4px;
    border: none;
    color: #CFD8DE;
    cursor: default;
    display: table;
    height: 43px;
    outline: none;
    overflow: hidden;
    position: relative;
    width: 100%;
    z-index: 98;
   
}


.Select-control:hover {
    //box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
}

.is-searchable.is-open > .Select-control {
    cursor: text;
}

.is-open > .Select-control {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    background: #fff;
    /* border-color: #b3b3b3 #ccc #d9d9d9; */
    text-align: left;
}

.is-open > .Select-control > .Select-arrow {
    border-color: transparent transparent #999;
    border-width: 0 5px 5px;
}

.is-searchable.is-focused:not(.is-open) > .Select-control {
    cursor: text;
}

.is-focused:not(.is-open) > .Select-control {
    border-color: #007eff;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);
}

.Select-placeholder,
:not(.Select--multi) > .Select-control .Select-value {
    bottom: 0;
    color: #393A3C;
    line-height: 37px;
    padding-left: 10px;
    padding-right: 10px;
    position: absolute;
    top: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
}

.has-value:not(.Select--multi) > .Select-control > .Select-value .Select-value-label,
.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value .Select-value-label {
    color: #333;
}

.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label,
.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label {
    cursor: pointer;
    text-decoration: none;
}

.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:hover,
.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:hover,
.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:focus,
.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:focus {
    color: #007eff;
    outline: none;
    text-decoration: underline;
}

.Select-input {
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
}

.Select-input > input {
    width: 100%;
    background: none transparent;
    border: 0 none;
    box-shadow: none;
    cursor: default;
    display: inline-block;
    font-family: inherit;
    font-size: inherit;
    height: 34px;
    margin: 0;
    outline: none;
    padding: 0;
    -webkit-appearance: none;
    color: #9e9e9e;
}

.is-focused .Select-input > input {
    cursor: text;
}

.has-value.is-pseudo-focused .Select-input {
    opacity: 0;
}

.Select-control:not(.is-searchable) > .Select-input {
    outline: none;
}

.Select-loading-zone {
    cursor: pointer;
    display: table-cell;
    position: relative;
    text-align: center;
    vertical-align: middle;
    width: 16px;
}

.Select-loading {
    animation: Select-animation-spin 400ms infinite linear;
    width: 16px;
    height: 16px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid #ccc;
    border-right-color: #333;
    display: inline-block;
    position: relative;
    vertical-align: middle;
}

.Select-clear-zone {
    animation: Select-animation-fadeIn 200ms;
    color: #999;
    cursor: pointer;
    display: table-cell;
    position: relative;
    text-align: right;
    vertical-align: middle;
    width: 7px !important;
}
.select-control span{
    width: 10px;

}
.Select-clear-zone:hover {
    color: #D0021B;
}

.Select-clear {
    display: inline-block;
    font-size: 18px;
    line-height: 1;
}

.Select--multi .Select-clear-zone {
    width: 17px;
}

.Select-arrow-zone {
    cursor: pointer;
    display: table-cell;
    position: relative;
    text-align: center;
    vertical-align: middle;
    width: 25px;
    padding:0px 5px;
}

.Select-arrow {
    border-color: #999 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 2.5px;
    display: inline-block;
    height: 0;
    width: 0;
}

.is-open .Select-arrow,
.Select-arrow-zone:hover > .Select-arrow {
    border-top-color: #666;
}

@keyframes Select-animation-fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.Select-menu-outer {
    color : #393A3C;
    text-align: left;
    background-color: #efefef;
    border-top-color: #e6e6e6; 
    /* box-shadow:0px 4px 16px 0px rgba(0,0,0,0.10); */
    box-sizing: border-box;
    margin-top: 3px;
    max-height: 200px;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 99;
    text-align: right;
    -webkit-overflow-scrolling: touch;
    padding-right: 10px
    ;
   
}
.Select-menu-outer div:hover {
    /* padding-bottom: 30px; */
 
    
}
.Select-menu {
    max-height: 198px;
    overflow-y: auto;

}

.Select-option {
    box-sizing: border-box;
    background-color: #fff;
    color: #666666;
    cursor: pointer;
    display: block;
    padding: 8px 10px;
    text-align: right;
}

.Select-option:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.Select-option.is-focused {
    background-color: rgba(0, 126, 255, 0.08);
    color: #333;
}

.Select-option.is-disabled {
    color: #9e9e9e;
    cursor: default;
}

.Select-noresults {
    box-sizing: border-box;
    color: #999999;
    cursor: default;
    display: block;
    padding: 8px 10px;
}

.Select--multi .Select-input {
    vertical-align: middle;
    margin-left: 10px;
    padding: 0;
}

.Select--multi.has-value .Select-input {
    margin-left: 5px;
}

.Select--multi .Select-value {
    background-color: #393A3C;
    border-radius: 4px;
    /* border: 1px solid rgba(0, 126, 255, 0.24); */
    color: #fff;
    display: inline-block;
    font-size: 0.9em;
    line-height: 1.4;
    margin-left: 5px;
    margin-top: 5px;
    vertical-align: top;
}

.Select--multi .Select-value-icon,
.Select--multi .Select-value-label {
    display: inline-block;
    vertical-align: middle;
}

.Select--multi .Select-value-label {
    border-bottom-right-radius: 2px;
    border-top-right-radius: 2px;
    cursor: default;
    padding: 2px 5px;
}

.Select--multi a.Select-value-label {
    color: #007eff;
    cursor: pointer;
    text-decoration: none;
}

.Select--multi a.Select-value-label:hover {
    text-decoration: underline;
}

.Select--multi .Select-value-icon {
    cursor: pointer;
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
    border-right: 1px solid rgba(0, 126, 255, 0.24);
    padding: 1px 5px 3px;
}

.Select--multi .Select-value-icon:hover,
.Select--multi .Select-value-icon:focus {
    background-color: rgba(0, 113, 230, 0.08);
    color: #0071e6;
}

.Select--multi .Select-value-icon:active {
    background-color: rgba(0, 126, 255, 0.24);
}

.Select--multi.is-disabled .Select-value {
    background-color: #fcfcfc;
    border: 1px solid #e3e3e3;
    color: #333;
}

.Select--multi.is-disabled .Select-value-icon {
    cursor: not-allowed;
    border-right: 1px solid #e3e3e3;
}

.Select--multi.is-disabled .Select-value-icon:hover,
.Select--multi.is-disabled .Select-value-icon:focus,
.Select--multi.is-disabled .Select-value-icon:active {
    background-color: #fcfcfc;
}

@keyframes Select-animation-spin {
    to {
        transform: rotate(1turn);
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/react-select.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;;;IAMI,sBAAsB;AAC1B;AACA;IACI,WAAW;;AAEf;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;;AAEnB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;AACA;;IAEI,cAAc;AAClB;;AAEA;IACI;MACE;KACD,8BAA8B;IAC/B,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,WAAW;;AAEf;;;AAGA;IACI,yCAAyC;AAC7C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kFAAkF;AACtF;;AAEA;;IAEI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,qBAAqB;AACzB;;AAEA;;;;IAII,cAAc;IACd,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,UAAU;IACV,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IAGI,sDAAsD;IACtD,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IAGI,wCAAwC;IACxC,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,WAAW;;AAEf;AACA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,sBAAsB;AAC1B;;AAWA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kDAAkD;IAClD,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC;IACA;;AAEJ;AACA;IACI,0BAA0B;;;AAG9B;AACA;IACI,iBAAiB;IACjB,gBAAgB;;AAEpB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,+CAA+C;IAC/C,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;IAC3B,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;;IAEI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["\n.Select {\n    position: relative;\n    width :100%;\n    border:1px solid #CFD8DE ;\n    border-radius :5px;\n}\n\n.Select,\n.Select div,\n.Select input,\n.Select span {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n.Select.is-disabled{\n    border:none;\n\n}\n.Select.is-disabled > .Select-control {\n    /* background-color: #f9f9f9; */\n    background-color: #c1c1c1 ;\n    color : #474646;\n\n}\n\n\n.Select.is-disabled > .Select-control:hover {\n    box-shadow: none;\n}\n\n.Select.is-disabled .Select-arrow-zone {\n    cursor: default;\n    pointer-events: none;\n}\n.Select.is-disabled .Select-placeholder,\n.Select.is-disabled > .Select-control .Select-value {\n    color: #3b3b3b;\n}\n\n.Select-control {\n    /* background-color: #dec9ce;\n     */\n     background-color:  transparent;\n    border-radius: 4px;\n    border: none;\n    color: #CFD8DE;\n    cursor: default;\n    display: table;\n    height: 43px;\n    outline: none;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    z-index: 98;\n   \n}\n\n\n.Select-control:hover {\n    //box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n\n.is-searchable.is-open > .Select-control {\n    cursor: text;\n}\n\n.is-open > .Select-control {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    background: #fff;\n    /* border-color: #b3b3b3 #ccc #d9d9d9; */\n    text-align: left;\n}\n\n.is-open > .Select-control > .Select-arrow {\n    border-color: transparent transparent #999;\n    border-width: 0 5px 5px;\n}\n\n.is-searchable.is-focused:not(.is-open) > .Select-control {\n    cursor: text;\n}\n\n.is-focused:not(.is-open) > .Select-control {\n    border-color: #007eff;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);\n}\n\n.Select-placeholder,\n:not(.Select--multi) > .Select-control .Select-value {\n    bottom: 0;\n    color: #393A3C;\n    line-height: 37px;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: absolute;\n    top: 0;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    \n}\n\n.has-value:not(.Select--multi) > .Select-control > .Select-value .Select-value-label,\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value .Select-value-label {\n    color: #333;\n}\n\n.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label,\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label {\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:hover,\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:hover,\n.has-value:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:focus,\n.has-value.is-pseudo-focused:not(.Select--multi) > .Select-control > .Select-value a.Select-value-label:focus {\n    color: #007eff;\n    outline: none;\n    text-decoration: underline;\n}\n\n.Select-input {\n    height: 32px;\n    padding-left: 10px;\n    padding-right: 10px;\n    vertical-align: middle;\n}\n\n.Select-input > input {\n    width: 100%;\n    background: none transparent;\n    border: 0 none;\n    box-shadow: none;\n    cursor: default;\n    display: inline-block;\n    font-family: inherit;\n    font-size: inherit;\n    height: 34px;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    -webkit-appearance: none;\n    color: #9e9e9e;\n}\n\n.is-focused .Select-input > input {\n    cursor: text;\n}\n\n.has-value.is-pseudo-focused .Select-input {\n    opacity: 0;\n}\n\n.Select-control:not(.is-searchable) > .Select-input {\n    outline: none;\n}\n\n.Select-loading-zone {\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 16px;\n}\n\n.Select-loading {\n    -webkit-animation: Select-animation-spin 400ms infinite linear;\n    -o-animation: Select-animation-spin 400ms infinite linear;\n    animation: Select-animation-spin 400ms infinite linear;\n    width: 16px;\n    height: 16px;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border: 2px solid #ccc;\n    border-right-color: #333;\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n}\n\n.Select-clear-zone {\n    -webkit-animation: Select-animation-fadeIn 200ms;\n    -o-animation: Select-animation-fadeIn 200ms;\n    animation: Select-animation-fadeIn 200ms;\n    color: #999;\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: right;\n    vertical-align: middle;\n    width: 7px !important;\n}\n.select-control span{\n    width: 10px;\n\n}\n.Select-clear-zone:hover {\n    color: #D0021B;\n}\n\n.Select-clear {\n    display: inline-block;\n    font-size: 18px;\n    line-height: 1;\n}\n\n.Select--multi .Select-clear-zone {\n    width: 17px;\n}\n\n.Select-arrow-zone {\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 25px;\n    padding:0px 5px;\n}\n\n.Select-arrow {\n    border-color: #999 transparent transparent;\n    border-style: solid;\n    border-width: 5px 5px 2.5px;\n    display: inline-block;\n    height: 0;\n    width: 0;\n}\n\n.is-open .Select-arrow,\n.Select-arrow-zone:hover > .Select-arrow {\n    border-top-color: #666;\n}\n\n@-webkit-keyframes Select-animation-fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes Select-animation-fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.Select-menu-outer {\n    color : #393A3C;\n    text-align: left;\n    background-color: #efefef;\n    border-top-color: #e6e6e6; \n    /* box-shadow:0px 4px 16px 0px rgba(0,0,0,0.10); */\n    box-sizing: border-box;\n    margin-top: 3px;\n    max-height: 200px;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 99;\n    text-align: right;\n    -webkit-overflow-scrolling: touch;\n    padding-right: 10px\n    ;\n   \n}\n.Select-menu-outer div:hover {\n    /* padding-bottom: 30px; */\n \n    \n}\n.Select-menu {\n    max-height: 198px;\n    overflow-y: auto;\n\n}\n\n.Select-option {\n    box-sizing: border-box;\n    background-color: #fff;\n    color: #666666;\n    cursor: pointer;\n    display: block;\n    padding: 8px 10px;\n    text-align: right;\n}\n\n.Select-option:last-child {\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.Select-option.is-focused {\n    background-color: rgba(0, 126, 255, 0.08);\n    color: #333;\n}\n\n.Select-option.is-disabled {\n    color: #9e9e9e;\n    cursor: default;\n}\n\n.Select-noresults {\n    box-sizing: border-box;\n    color: #999999;\n    cursor: default;\n    display: block;\n    padding: 8px 10px;\n}\n\n.Select--multi .Select-input {\n    vertical-align: middle;\n    margin-left: 10px;\n    padding: 0;\n}\n\n.Select--multi.has-value .Select-input {\n    margin-left: 5px;\n}\n\n.Select--multi .Select-value {\n    background-color: #393A3C;\n    border-radius: 4px;\n    /* border: 1px solid rgba(0, 126, 255, 0.24); */\n    color: #fff;\n    display: inline-block;\n    font-size: 0.9em;\n    line-height: 1.4;\n    margin-left: 5px;\n    margin-top: 5px;\n    vertical-align: top;\n}\n\n.Select--multi .Select-value-icon,\n.Select--multi .Select-value-label {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.Select--multi .Select-value-label {\n    border-bottom-right-radius: 2px;\n    border-top-right-radius: 2px;\n    cursor: default;\n    padding: 2px 5px;\n}\n\n.Select--multi a.Select-value-label {\n    color: #007eff;\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.Select--multi a.Select-value-label:hover {\n    text-decoration: underline;\n}\n\n.Select--multi .Select-value-icon {\n    cursor: pointer;\n    border-bottom-left-radius: 2px;\n    border-top-left-radius: 2px;\n    border-right: 1px solid rgba(0, 126, 255, 0.24);\n    padding: 1px 5px 3px;\n}\n\n.Select--multi .Select-value-icon:hover,\n.Select--multi .Select-value-icon:focus {\n    background-color: rgba(0, 113, 230, 0.08);\n    color: #0071e6;\n}\n\n.Select--multi .Select-value-icon:active {\n    background-color: rgba(0, 126, 255, 0.24);\n}\n\n.Select--multi.is-disabled .Select-value {\n    background-color: #fcfcfc;\n    border: 1px solid #e3e3e3;\n    color: #333;\n}\n\n.Select--multi.is-disabled .Select-value-icon {\n    cursor: not-allowed;\n    border-right: 1px solid #e3e3e3;\n}\n\n.Select--multi.is-disabled .Select-value-icon:hover,\n.Select--multi.is-disabled .Select-value-icon:focus,\n.Select--multi.is-disabled .Select-value-icon:active {\n    background-color: #fcfcfc;\n}\n\n@keyframes Select-animation-spin {\n    to {\n        transform: rotate(1turn);\n    }\n}\n\n@-webkit-keyframes Select-animation-spin {\n    to {\n        -webkit-transform: rotate(1turn);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
